"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartDrawerFooter = void 0;
const base_component_1 = require("../../components/base-component");
const dom_1 = require("../../utils/dom");
const utils_1 = require("../../utils/utils");
const CART_DRAWER_SELECTOR = 'cart-drawer';
const CART_DRAWER_FOOTER_SELECTOR = 'cart-drawer-footer';
class CartDrawerFooter extends base_component_1.BaseComponent {
    mountComponent() {
        const cartDrawer = (0, utils_1.$elParent)(CART_DRAWER_SELECTOR, this);
        cartDrawer?.on('update-nodes', this.handleCartDrawerUpdate);
    }
    unmountComponent() {
        const cartDrawer = (0, utils_1.$elParent)(CART_DRAWER_SELECTOR, this);
        cartDrawer?.off('update-nodes', this.handleCartDrawerUpdate);
    }
    handleCartDrawerUpdate = ({ node }) => {
        (0, dom_1.replaceNodeChildren)(this, (0, utils_1.$el)(CART_DRAWER_FOOTER_SELECTOR, node));
    };
}
exports.CartDrawerFooter = CartDrawerFooter;
